/* src/app/modules/unauthenticated/conditions/conditions.component.css */
h3 {
  margin-top: 50px;
}
/*# sourceMappingURL=conditions.component-JBAV6X47.css.map */
